import SeoContentDetail from './SeoContentDetail.container';

export default SeoContentDetail;
